<template>
    <gestion>
        <div class="space-y-6 sm:px-6 lg:px-0 lg:col-span-9">
            <section aria-labelledby="payment_details_heading">
                <page
                    :initial-account="account"
                    class="shadow sm:rounded-md sm:overflow-hidden"
                    :submit-text="$t('forms.account.save')"
                    @updated="updated"
                >
                    <template #leftButton="{isEdited}">
                        <activix-link
                            :route="$route('preview', $page.props.account.sid)"
                            v-if="!isEdited"
                        >
                            {{ $t('menu.gestion.preview') }}
                        </activix-link>
                    </template>
                    <div>
                        <h2 id="payment_details_heading" class="text-lg leading-6 font-medium text-gray-900">
                            {{ $t('gestion.page.title') }}
                        </h2>
                        <p class="mt-1 text-sm leading-5 text-gray-500">
                            {{ $t('gestion.page.subtitle') }}
                        </p>
                    </div>
                </page>
            </section>
        </div>
    </gestion>
</template>

<script>
    import Gestion from '@/layouts/Gestion.vue';
    import Page from '@/components/forms/Page.vue';
    import ActivixLink from '@/components/ui/ActivixLink.vue';

    export default {
        components: {
            ActivixLink,
            Gestion,
            Page,
        },

        props: {
            account: {
                type: Object,
                default: () => {},
            },
        },

        methods: {
            updated() {
                this.$notify.success(this.$t('general.editsaved'));
            },
        },
    };
</script>
